import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeftLarge from 'wix-ui-icons-common/ChevronLeftLarge';
import ChevronRightLarge from 'wix-ui-icons-common/ChevronRightLarge'; // This is here and not in the test setup because we don't want consumers to need to run it as well

import '../common/match-media-register';
import Slider from 'react-slick';
import './Carousel.global.scss';
import { st, classes } from './Carousel.st.css';
import Pagination from './Pagination';
import SliderArrow from './SliderArrow';
import Loader from '../Loader';
import Proportion from '../Proportion';
var AUTOPLAY_SPEED = 2000;
var TRANSITION_SPEED = 600;
var dataHooks = {
  imagesContainer: 'images-container',
  carouselImage: 'carousel-img',
  loader: 'loader',
  prevButton: 'prev-button',
  nextButton: 'next-button',
  pageNavigation: function pageNavigation(index) {
    return "page-navigation-".concat(index);
  }
};

var WrappedSliderArrow = function WrappedSliderArrow(_ref) {
  var currentSlide = _ref.currentSlide,
      slideCount = _ref.slideCount,
      rest = _objectWithoutProperties(_ref, ["currentSlide", "slideCount"]);

  return /*#__PURE__*/React.createElement(SliderArrow, rest);
};

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_resolveSliderSettings", function (_ref2) {
      var infinite = _ref2.infinite,
          autoplay = _ref2.autoplay,
          dots = _ref2.dots,
          variableWidth = _ref2.variableWidth,
          buttonSkin = _ref2.buttonSkin,
          initialSlideIndex = _ref2.initialSlideIndex,
          afterChange = _ref2.afterChange,
          beforeChange = _ref2.beforeChange;
      return {
        infinite: infinite,
        autoplay: autoplay,
        speed: TRANSITION_SPEED,
        autoplaySpeed: AUTOPLAY_SPEED,
        initialSlide: initialSlideIndex,
        dots: dots,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: variableWidth,
        afterChange: afterChange,
        beforeChange: beforeChange,
        nextArrow: /*#__PURE__*/React.createElement(WrappedSliderArrow, {
          dataHook: dataHooks.nextButton,
          buttonSkin: buttonSkin,
          icon: /*#__PURE__*/React.createElement(ChevronRightLarge, null)
        }),
        prevArrow: /*#__PURE__*/React.createElement(WrappedSliderArrow, {
          dataHook: dataHooks.prevButton,
          buttonSkin: buttonSkin,
          icon: /*#__PURE__*/React.createElement(ChevronLeftLarge, null)
        }),
        appendDots: function appendDots(pages) {
          return /*#__PURE__*/React.createElement(Pagination, {
            className: classes.pagination,
            pages: pages
          });
        },
        customPaging: function customPaging(i) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.pageNavigation,
            "data-hook": dataHooks.pageNavigation(i)
          }, i);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_renderImages", function (images) {
      return images.map(function (image, index) {
        return /*#__PURE__*/React.createElement(Proportion, {
          key: "".concat(index).concat(image.src),
          aspectRatio: Proportion.PREDEFINED_RATIOS.landscape
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            height: '100%'
          },
          "data-hook": dataHooks.imagesContainer,
          "data-is-loading": _this._isLoading()
        }, /*#__PURE__*/React.createElement("img", _extends({}, image, {
          "data-hook": dataHooks.carouselImage,
          className: classes.image,
          onLoad: function onLoad() {
            return _this._onImageLoad();
          }
        }))), _this._isLoading() && /*#__PURE__*/React.createElement("div", {
          className: classes.loader
        }, /*#__PURE__*/React.createElement(Loader, {
          dataHook: "loader",
          size: "small"
        })));
      });
    });

    _this.state = {
      sliderSettings: _this._resolveSliderSettings(props),
      loadedImageCount: 0
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          className = _this$props.className,
          images = _this$props.images,
          children = _this$props.children;
      var sliderSettings = this.state.sliderSettings;
      var hasImages = !children && images.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: st(classes.root, className)
      }, /*#__PURE__*/React.createElement(Slider, sliderSettings, children, hasImages && this._renderImages(images)));
    }
  }, {
    key: "_onImageLoad",
    value: function _onImageLoad() {
      this.setState(function (state) {
        var loadedImageCount = state.loadedImageCount + 1;
        return {
          loadedImageCount: loadedImageCount
        };
      });
    }
  }, {
    key: "_isLoading",
    value: function _isLoading() {
      return this.state.loadedImageCount < this.props.images.length;
    }
  }]);

  return Carousel;
}(React.Component);

_defineProperty(Carousel, "displayName", 'Carousel');

_defineProperty(Carousel, "propTypes", {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** A single CSS class name to be appended to the Carousel's wrapper element. */
  className: PropTypes.string,

  /** Array of objects where each contains the `src` of an image (in \<img src="your_src" /\>) */
  images: PropTypes.array,

  /** Any element to render inside */
  children: PropTypes.node,

  /** Sets the skin of the arrow buttons */
  buttonSkin: PropTypes.oneOf(['standard', 'inverted']),

  /** Images loop endlessly */
  infinite: PropTypes.bool,

  /** Auto-playing of images */
  autoplay: PropTypes.bool,

  /** Show dots */
  dots: PropTypes.bool,

  /** Variable width of children */
  variableWidth: PropTypes.bool,

  /** An index of the slide to start on */
  initialSlideIndex: PropTypes.number,

  /** Index change callback. `index => ...` */
  afterChange: PropTypes.func,

  /** Index change callback. `(oldIndex, newIndex) => ...` */
  beforeChange: PropTypes.func
});

_defineProperty(Carousel, "defaultProps", {
  infinite: true,
  dots: true,
  variableWidth: false,
  initialSlideIndex: 0,
  images: [],
  buttonSkin: 'standard'
});

export default Carousel;